<template>
    <a :href="urlWishList" rel="nofollow" id="wishlist-count" :aria-label="$translate('Ceres::Template.wishList')">
        <i class="fa" :class="{'fa-heart-o': !wishListCount, 'fa-heart': wishListCount}" aria-hidden="true"></i>
        <span class="badge-right" :class="{'d-none': !wishListCount}">{{ wishListCount }}</span>
    </a>
</template>


<script>
export default {
    computed:
    {
        wishListCount()
        {
            return this.$store.getters.wishListCount;
        },

        urlWishList()
        {
            return App.urls.wishList;
        }
    }
}
</script>
